module.exports = __webpack_public_path__ + "static/img/ross_noble_ani_extended_size_00067-fs8.fbd3194.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/animation/ross_noble_ani_extended_size_00067-fs8.png
// module id = 220
// module chunks = 0